import ProgressLabel from './ProgressLabel';

// export { TextProps } from './ProgressLabel';
export default ProgressLabel;
